export const faqData = [
    {
        question: 'question_1',
        answer: 'answer_1'
    },
    {
        question: 'question_2',
        answer: 'answer_2'
    },
    {
        question: 'question_3',
        answer: 'answer_3'
    },
    {
        question: 'question_4',
        answer: 'answer_4'
    },
    {
        question: 'question_5',
        answer: 'answer_5'
    },
    {
        question: 'question_6',
        answer: 'answer_6'
    },
    {
        question: 'question_7',
        answer: 'answer_7'
    },
    {
        question: 'question_8',
        answer: 'answer_8'
    },
    {
        question: 'question_9',
        answer: 'answer_9'
    },
    {
        question: 'question_10',
        answer: 'answer_10'
    }

]